import { type FC } from 'react'
import { IconButton, InputAdornment } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { getPaymentIcon } from '@DS/components/icons/paymentIcons'

import * as styles from './styles'

const CalendarIcon = getPaymentIcon('calendar')

export type CalendarButtonProps = {
  name: string
  onClick: VoidFunction
  disabled?: boolean
  ariaLabel?: string
}

const CalendarButton: FC<CalendarButtonProps> = ({ ariaLabel, name, onClick, disabled = false }) => {
  const theme = useTheme()

  return (
    <InputAdornment position="end">
      <IconButton
        aria-label={ariaLabel}
        data-test={`${name}-calendar-button`}
        onClick={onClick}
        disabled={disabled}
        css={styles.buttonFocus(theme)}
      >
        <CalendarIcon css={styles.icon(theme)} />
      </IconButton>
    </InputAdornment>
  )
}

export default CalendarButton
